// components/Desktop/Components/Social.js

import React from 'react';
import styles from './Social.module.css';

// Replace these with your actual image paths:
import asset1 from '../../../assets/social-asset1.png';
import asset2 from '../../../assets/social-asset2.png';
import asset3 from '../../../assets/social-asset3.png';
import asset4 from '../../../assets/social-asset4.png';
import card1 from '../../../assets/social-card1.png';
import card2 from '../../../assets/social-card2.png';
import card3 from '../../../assets/social-card3.png';

const Social = () => {
  return (
    <section className={styles.social}>
      <div className={styles.leftColumn}>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>SOCIAL</h1>
        </div>

        <div className={styles.assetContainer}>
          <img src={asset1} alt="Asset 1" className={styles.asset1} />
          <img src={asset2} alt="Asset 2" className={styles.asset2} />
          <img src={asset3} alt="Asset 3" className={styles.asset3} />
          <div className={styles.assetSpacing} /> 
          <img src={asset4} alt="Asset 4" className={styles.asset4} />
        </div>
        <div className={styles.textContainer}>
     <p className={styles.paragraph}>No swiping through people</p></div>
      </div> {/* End of leftColumn */}
     <div className={styles.rightColumn}>
        <div className={styles.cardContainer}>
          <img src={card1} alt="Card 1" className={styles.card} />
  
          <div className={styles.cardMiddleContainer}> 
            <img src={card2} alt="Card 2" className={styles.cardMiddle} /> 
          </div>
  
          <img src={card3} alt="Card 3" className={styles.cardLast} />
        </div>
     </div>

    </section>
  );
};

export default Social;
